function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClockShifts = function SvgClockShifts(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, React.createElement("path", {
    style: {
      color: "#000000",
      enableBackground: "accumulate"
    },
    d: "m 50,965.36219 c -20.43443,0 -37,16.56556 -37,37.00001 0,20.4344 16.56557,37 37,37 20.43444,0 37,-16.5656 37,-37 0,-20.43444 -16.56556,-37 -37,-37 z m 0,9 c 1.1046,0 2,0.8954 2,2 l 0,25.18751 16.375,16.375 c 0.78107,0.7811 0.78107,2.0314 0,2.8125 -0.78107,0.7811 -2.03142,0.781 -2.8125,0 -5.64367,-5.6543 -11.31444,-11.3717 -16.96875,-16.9688 C 48.23182,1003.4065 48,1002.9145 48,1002.3622 l 0,-26.00001 c 0,-1.1046 0.8954,-2 2,-2 z",
    fill: "#000000",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClockShifts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock-shifts.f7b9fe1f.svg";
export { ForwardRef as ReactComponent };